/*
 * Copyright (c) 2020 liwei<linewei@gmail.com>
 *
 * This program is free software: you can use, redistribute, and/or modify
 * it under the terms of the GNU Affero General Public License, version 3
 * or later ("AGPL"), as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IEventType {
    type: string | number;
    data?: any;
    error?: string;
}

export enum EventType {
    socket_connected = 'socket_connected',
    socket_disconnected = 'socket_disconnected',

    media_newPeer = 'media_newPeer',
    media_peerClose = 'media_peerClosed',
    media_peerProducersClosed = 'media_peerProducersClosed',
    media_consumerClosed = 'media_consumerClosed',
    media_consumerPaused = 'media_consumerPaused',
    media_consumerResumed = 'media_consumerResumed',
    media_newConsumer = 'media_newConsumer',
    media_consumerScore = 'media_consumerScore',

    video_iCanPlay = 'video_iCanPlay',
    video_iCantPlay = 'video_iCantPlay',
    video_playable = 'video_playable',
    video_notPlayable = 'video_notPlayable',

    chat_message = 'chat_message',
    prompter_update = 'prompter_update',
    chat_emoji = 'chat_emoji',

    popover_docSelectClosed = 'popover_docSelectClosed',
    popover_settingClosed = 'popover_settingClosed',
    popover_emojiClosed = 'popover_emojiClosed',
    popover_shareClosed = 'popover_shareClosed',
    popover_moreClosed = 'popover_moreClosed',
    popover_selectPencilClosed = 'popover_selectPencilClosed',
    popover_informationClosed = 'popover_informationClosed',

    document_docSelect = 'document_docSelect',
    document_docImport = 'document_docImport',
    document_syncDocInfo = 'document_syncDocInfo',

    pdftranscode_start = 'pdftranscode_start',
    pdftranscode_end = 'pdftranscode_end',
    pdftranscode_progress = 'pdftranscode_progress',

    show_start = 'show_start',
    show_stop = 'show_stop',
    show_take2 = 'show_take2',
    end_scene = 'end_scene',
    show_connectVideo = 'show_connectVideo',
    show_connectApproval = 'show_connectApproval',
    show_disconnectVideo = 'show_disconnectVideo',
    show_announcementTextChange = 'show_announcementTextChange',
    show_muted = 'show_muted',
    show_unmuted = 'show_unmuted',
    show_roomUpdate = 'show_roomUpdate',
    show_invokeControlAction = 'show_invokeControlAction',
    show_invokeAction = 'show_invokeAction',
    show_invokeBit = 'show_invokeBit',
    show_invokePositionUpdate = 'show_invokePositionUpdate',
    show_invokePositionStageOptionUpdate = 'show_invokePositionStageOptionUpdate',
    show_layoutChanged = 'show_layoutChanged',
    show_transitionMode = 'show-transition-mode',
    show_newCompositionInTimeline = 'show_newComposition',

    bit_started_loading = 'bit_start_loading',
    bit_finished_loading = 'bit_finished_loading',

    show_dynamicValuesChanged = 'show_dynamicValuesChanged',

    peer_changeRole = 'peer_changeRole',

    draw_action = 'draw_action',

    main_switchComponent = 'main_switchComponent',

    ask_to_participate = 'ask_to_participate',
    response_to_participation_request = 'response_to_participation_request',
    ready_to_participate = 'ready_to_participate',
}

@Injectable({
    providedIn: 'root',
})
export class EventbusService {
    public socket$ = new Subject();
    public media$ = new Subject();
    public chat$ = new Subject();
    public popover$ = new Subject();
    public pdftranscode$ = new Subject();
    public document$ = new Subject();
    public show$ = new Subject();
    public draw$ = new Subject();
    public main$ = new Subject();
    public peer$ = new Subject();
    public syncStages$ = new Subject();

    constructor() {}
}
